import { Share, SharesTitle } from 'types';

export const getTitleByShare = (sharesTitles: SharesTitle[], share: Share) =>
  sharesTitles?.find((title: SharesTitle) =>
    title?.shares?.some((s) => s?._id === share?._id)
  );
